/**
 * Во что складывается список видов в селекторе.
 *
 * Заголовки появляются только тогда, когда есть что разделять: пока район
 * один — а это сегодняшнее состояние кабинета, — список остаётся плоским.
 * Подпись над единственной группой ничего не сообщает, а место занимает.
 *
 * Отдаётся КЛЮЧ каталога, а не фраза: готовый текст втащил бы язык в модуль
 * логики, а словами распоряжается компонент.
 */

import type { SpeciesItem } from '../api'

export interface SpeciesGroup {
  /** null — группа без заголовка (делить не на что). */
  labelKey: string | null
  items: SpeciesItem[]
}

export function speciesGroups(
  inView: SpeciesItem[],
  outOfView: SpeciesItem[],
): SpeciesGroup[] {
  if (outOfView.length === 0) {
    return inView.length ? [{ labelKey: null, items: inView }] : []
  }
  const groups: SpeciesGroup[] = []
  if (inView.length) groups.push({ labelKey: 'models.species.groupInView', items: inView })
  groups.push({ labelKey: 'models.species.groupOutOfView', items: outOfView })
  return groups
}
